<div class="dialogContainer">
  <div>
    <table>
      <tr>
        <td><label>{{ warrantyText }}</label></td>
      </tr>
    </table>
  </div>
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
    <button class="primary-button" matButton="elevated" (click)="close()">close</button>
  </span>
  </div>
</div>
